import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import moment from "moment"

const bookingDataListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.id}</>,
    },
    {
      text: "Date",
      dataField: "start_date_utc",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <> {moment(item?.start_date_utc).format("MMM DD, YYYY h:mma")}</>
      ),
    },
    {
      text: "Booker's Name",
      dataField: "booker_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.booker_name}</>,
    },
    {
      text: "Booker's Email",
      dataField: "booker_email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.booker_email}</>,
    },
    {
      text: "Order Total",
      dataField: "amount",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>{item?.amount ? parseFloat(item?.amount)?.toFixed(2) + "$" : "-"}</>
      ),
    },
    {
      text: "Calendar Group",
      dataField: "calendar_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.calendar_name}</>,
    },
    {
      text: "Sub Calendar",
      dataField: "booking_type_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.booking_type_name}</>,
    },
    {
      text: "Booking Status",
      dataField: "booking_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.booking_status}</>,
    },
    {
      text: "Billing Status",
      dataField: "billing_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>{item?.billing_status ? item?.billing_status : "-"}</>
      ),
    },
    {
      text: "Refund Status",
      dataField: "refund_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>{!item?.refund_status ? "No Refund" : item?.refund_status}</>
      ),
    },
    {
      text: "Refunded Amount",
      dataField: "refunded_amount",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>
          {!item?.refunded_amount
            ? "-"
            : parseFloat(item?.refunded_amount)?.toFixed(2) + "$"}
        </>
      ),
    },
    {
      text: "Name",
      dataField: "user_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.user_name}</>,
    },
    {
      text: "Email",
      dataField: "user_email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.user_email}</>,
    },
  ]
}

export default bookingDataListColumns
